import { ApolloLink, DefaultContext, GraphQLRequest } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAuthToken } from "@/helpers/authentication/authentication.helpers";

export const authRestLink: ApolloLink = setContext(
  (_: GraphQLRequest, prevContext: DefaultContext) => {
    const { headers } = prevContext;
    const token = getAuthToken();
    return {
      headers: {
        ...headers,
        ...(token && { authorization: `Bearer ${token}` }),
      },
    };
  }
);

/**
 * Set header with token, everytime a graphQL request is being excuted
 * Ref: https://www.apollographql.com/docs/link/links/context
 */
export const authGraphqlLink: ApolloLink = setContext(
  async (_, { headers }) => {
    /* istanbul ignore next */
    const token = getAuthToken();
    return {
      headers: {
        ...headers,
        authorization: token,
      },
    };
  }
);
